import './Splash.css';
import React from 'react';
import { Link } from 'react-router-dom';

function Splash() {

  function random(max) {
    return Math.random() * max;
  }
  
  function makeStar(type) {
    var div = React.createElement('div');
    div.props.className = "star " + type;
    let delayLength = type === "small" ? 5 : (type === "medium" ? 4 : /*big*/ 3);
    let _top = Math.floor(random(window.innerHeight)) + "px";
    let _animationDelay = "-" + random(delayLength) + "s";
    div.props.style = {top: _top, animationDelay: _animationDelay};
    return div;
  }

  function getStars() {
    let stars = [];
    for (let i = 0; i < 20; i++) {
      stars.push(makeStar("small"));
      stars.push(makeStar("small"));
      stars.push(makeStar("medium"));
      stars.push(makeStar("big"));
    }
    return stars;
  }

  return (
    <div className="splash-page athabasca">
      <div id="splash" className="splash-container">
          <div className="splash">
              <h1 className="splash-head" style={{fontWeight: 'bold'}}><b>BATTLEDRIFT</b></h1>
              <p className="splash-subhead">
                  Local multiplayer battles in space
              </p>
              <p>
                <Link to="/BATTLEDRIFT" className="pure-button pure-button-primary" >Learn More</Link>
              </p>
              <p>
                <Link to="/BATTLEDRIFT-DEMO" className="pure-button pure-button-primary" >Play the Demo!</Link>
              </p>
          </div>
          {getStars()}
      </div>
    </div>
  );
}

export default Splash;
